export const SET_CUSTOMIZATION = 'SET_CUSTOMIZATION'
